var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c("DIV", [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("ItpFormInput", {
              attrs: {
                autofocus: !_vm.isReadonly,
                name: "name",
                placeholder: _vm._f("pgettext")("Name", "InvoiceParty"),
                readonly: _vm.isReadonly,
                required: ""
              },
              model: {
                value: _vm.item.name,
                callback: function($$v) {
                  _vm.$set(_vm.item, "name", $$v)
                },
                expression: "item.name"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.item.address
          ? _c("div", { staticClass: "form-row" }, [
              _c(
                "div",
                { staticClass: "form-group col-2" },
                [
                  _c("ItpFormInput", {
                    attrs: {
                      name: "postal_code",
                      placeholder: _vm._f("pgettext")(
                        "Postal code",
                        "InvoiceParty"
                      ),
                      readonly: _vm.isReadonly
                    },
                    model: {
                      value: _vm.item.address.postal_code,
                      callback: function($$v) {
                        _vm.$set(_vm.item.address, "postal_code", $$v)
                      },
                      expression: "item.address.postal_code"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group col-10" },
                [
                  _c("ItpFormInput", {
                    attrs: {
                      name: "city",
                      placeholder: _vm._f("pgettext")("City", "InvoiceParty"),
                      readonly: _vm.isReadonly
                    },
                    model: {
                      value: _vm.item.address.city,
                      callback: function($$v) {
                        _vm.$set(_vm.item.address, "city", $$v)
                      },
                      expression: "item.address.city"
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.item.address
          ? _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("ItpFormInput", {
                  attrs: {
                    name: "address",
                    placeholder: _vm._f("pgettext")("Address", "InvoiceParty"),
                    readonly: _vm.isReadonly
                  },
                  model: {
                    value: _vm.item.address.address,
                    callback: function($$v) {
                      _vm.$set(_vm.item.address, "address", $$v)
                    },
                    expression: "item.address.address"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("ItpFormInput", {
              attrs: {
                name: "tax_number",
                placeholder: _vm._f("pgettext")("Tax number", "InvoiceParty"),
                readonly: _vm.isReadonly
              },
              model: {
                value: _vm.item.tax_number,
                callback: function($$v) {
                  _vm.$set(_vm.item, "tax_number", $$v)
                },
                expression: "item.tax_number"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("ItpFormInput", {
              attrs: {
                name: "account_number",
                placeholder: _vm._f("pgettext")(
                  "Account number",
                  "InvoiceParty"
                ),
                readonly: _vm.isReadonly
              },
              model: {
                value: _vm.item.account_number,
                callback: function($$v) {
                  _vm.$set(_vm.item, "account_number", $$v)
                },
                expression: "item.account_number"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("ItpFormInput", {
              attrs: {
                name: "bank",
                placeholder: _vm._f("pgettext")("Bank", "InvoiceParty"),
                readonly: _vm.isReadonly
              },
              model: {
                value: _vm.item.bank,
                callback: function($$v) {
                  _vm.$set(_vm.item, "bank", $$v)
                },
                expression: "item.bank"
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }